<template>
    <div class="own-business-admin">
        <customModalDialog :settings="customModalSettings"></customModalDialog>

        <div class="map-search">
            <span class="seach-submit"></span>

            <md-autocomplete
                    :md-options="autocompleteBusinessCollection"
                    @md-changed="onSearchPlaceAutocomplete"
                    @md-selected="onSearchPlaceSelect"
                    class="search_md_autocomplete"
                    v-model="searchBusinessQuery">
                <template class="businessDropdownItem" slot="md-autocomplete-item"
                          slot-scope="{ item, term }">
                    <div class="businessDropdown__wrapper" v-if="item.uid">
                        <img :src='item.preview' class="businessDropdown__image">
                        <div class="businessDropdown__item">
                            <md-highlight-text :md-term="term">{{ item.name }}</md-highlight-text>
                            <md-highlight-text :md-term="term">{{ item.address }}</md-highlight-text>
                        </div>
                    </div>
                    <div class="businessDropdown__wrapper" v-else>
                        <div class="businessDropdown__item">
                            <md-highlight-text :md-term="term">{{ item.main_text }}</md-highlight-text>
                            <md-highlight-text :md-term="term">{{ item.secondary_text }}</md-highlight-text>
                        </div>
                    </div>
                </template>
            </md-autocomplete>

            <span @click="closeDialog" class="close-search">
                <i class="icon-close-search"></i>
            </span>
        </div>

        <gmap-map
                :center="center"
                :options="mapOptions"
                :zoom="zoom"
                class="g-map-class"
                ref="mapModal"
                style="width: 100%; height: 100%;"
        >
            <gmap-cluster>
                <gmap-custom-marker
                        :key="index" :marker="{lat: item.location.lat, lng: item.location.lng}"
                        class="map-marker"
                        v-for="(item, index) in rates"
                >
                    <img height="33" src="@/assets/re/pin.svg" width="16"/>
                </gmap-custom-marker>
            </gmap-cluster>

            <gmap-custom-marker :marker="{lat: myLocation.lat, lng: myLocation.lng}"
                                v-if="myLocation.lat && myLocation.lng">
                <img height="52" src="@/assets/icons/my-location.svg" width="28"/>
            </gmap-custom-marker>

        </gmap-map>

        <div @click="showEnterQuestionIdDialog({
            uid: latestConnectedPlaceUid,
            name: latestConnectedPlaceName
        })"
             class="latest-place-btn" v-if="latestConnectedPlaceUid">
            Use latest place {{latestConnectedPlaceName}}
        </div>

        <button @click="onMapModalGeolocateClick()" class="getgeo"></button>

    </div>
</template>

<script>
    // Import plugins
    import Autocomplete from 'v-autocomplete'
    import 'v-autocomplete/dist/v-autocomplete.css'
    import GmapCustomMarker from 'vue2-gmap-custom-marker';
    import vSelect from 'vue-select'
    // Import components
    import ToolBar from '@/components/widgets/toolBar'
    import mapMixin from '@/mixins/mapMixin';
    import errorMixin from '@/mixins/errorMixin';
    import questionMixin from '@/mixins/questionMixin';
    import customModalDialog from '@/components/widgets/customModalDialog';
    import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';

    export default {
        name: 'adminAddPlaceQFlow',

        mixins: [mapMixin, errorMixin, questionMixin],

        components: {
            customModalDialog,
            Autocomplete,
            ToolBar,
            'gmap-custom-marker': GmapCustomMarker,
            vSelect
        },

        data() {
            return {
                searchBusinessQuery: '',
                autocompleteBusinessCollection: [],
                myLocation: {
                    lat: null,
                    lng: null
                },
                latestConnectedPlaceUid: null,
                latestConnectedPlaceName: null,
                customModalSettings: {},
                isInitialLocationSet: false,
                center: {
                    lat: +localStorage.getItem('lat'),
                    lng: +localStorage.getItem('lng')
                },
                zoom: 10,
                mapOptions: {
                    zoomControl: false,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: false,
                    disableDefaultUi: false,
                    gestureHandling: 'greedy'
                },
                isActive: false
            }
        },

        computed: {
            ...mapState({
                accessToken: state => state.auth.accessToken,
                makeOwnerBool: state => state.owner.makeOwnerBool,
                userInfo: state => state.auth.userInfo
            }),

            ...mapGetters({
                isUserAdmin: 'auth/isUserAdmin',
                isUserClient: 'auth/isUserClient',
                isUserOwner: 'auth/isUserOwner',
                isUserOrgManager: 'auth/isUserOrgManager',
                isUserSiteManager: 'auth/isUserSiteManager',
                hasOwnOrganization: 'auth/hasOwnOrganization',
                hasOwnPlace: 'auth/hasOwnPlace',
                ownPlaces: 'auth/ownPlaces',
                getOwnPlace: 'auth/getOwnPlace',
                siteManagerPlaces: 'auth/siteManagerPlaces',
                isAddSite: 'organization/isAddSite',
                hasOrgManagerPlace: 'auth/hasOrgManagerPlace',
                orgManagerPlaces: 'auth/orgManagerPlaces',
            }),

        },

        watch: {},

        methods: {
            ...mapActions({
                searchPlaceAutocomplete: 'search/searchPlaceAutocomplete',
                updateQuestion: 'question/updateQuestion',
                fetchPlace: 'place/fetchPlace',
                createPlaceAction: 'place/createPlace',
                connectOwnerToPlace: 'place/connectOwnerToPlace',
                connectQuestionByIdToPlace: 'question/connectQuestionByIdToPlace',
                fetchUserInfo: 'auth/fetchUserInfo',
                addSite: 'owner/addSite',
                fetchSelectedStartTemplates: 'question/fetchSelectedStartTemplates',
                connectSelectedStartTemplates: 'question/connectSelectedStartTemplates',
                clearSelectedStartTemplates: 'question/clearSelectedStartTemplates',
            }),

            ...mapMutations({
                removeKeys: 'auth/removeKeys'
            }),

            onMapModalGeolocateClick() {
                this.geolocate({zoom: 18})
            },

            getLabel(item) {
                if (item) {
                    return item.main_text || item
                }
                return ''
            },

            async onSearchPlaceSelect(place) {
                this.searchBusinessQuery = place.main_text
                if (!place.uid) {
                    this.selectedPlace(place.placeId)
                } else {
                    this.showEnterQuestionIdDialog(place)
                }
            },

            async onSearchPlaceAutocomplete(searchText) {
                let result = await this.searchPlaceAutocomplete(searchText)
                this.autocompleteBusinessCollection = result.sites.concat(result.items)
            },

            onCloseSearch() {
                this.$store.commit("setSessionToken", null)
            },

            async connectSpecificQuestionToPlaceForAdmin(payload) {
                try {
                    let body = payload.place
                    body.name = body.place_name || body.name
                    body.question_id = payload.input.value
                    body.place_id = body.uid
                    let response = await this.connectQuestionByIdToPlace({
                        body: body
                    })
                    let data = response.data
                    this.latestConnectedPlaceUid = data.place_uid
                    this.latestConnectedPlaceName = data.place_name
                    localStorage.setItem('ADMIN_latestConnectedPlaceUid', this.latestConnectedPlaceUid)
                    localStorage.setItem('ADMIN_latestConnectedPlaceName', this.latestConnectedPlaceName)
                    this.customModalSettings = {
                        message: this.translate('bflow_AddQuestionSuccess'),
                        icon: 'ic_allow.svg',
                        sectionClass: 'leftAlign',
                        questionUid: data.uid,
                        input: {
                            label: this.translate('Question'),
                            value: data.text,
                            disabled: true
                        },
                        additionalInputs: [
                            {
                                label: this.translate('Location'),
                                value: data.optional
                            },
                        ],
                        showCancelButton: true,
                        okButtonText: this.translate('Save'),
                        onOkHandler: this.setupLocationForNewQuestion,
                        cancelButtonText: this.translate('OK'),
                        onCancelHandler: this.businessFlowDone
                    }
                } catch (e) {
                    console.log(`zzxxx_ error ${e}`)
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                }
            },

            businessFlowDone() {

            },

            async setupLocationForNewQuestion(payload) {
                const body = {
                    text: payload.input.value,
                    optional: payload.additionalInputs[0].value
                };
                try {
                    const response = await this.updateQuestion({
                        questionId: payload.questionUid,
                        body
                    })
                    if (response.success) {
                        this.customModalSettings = {
                            message: this.translate('Success'),
                            icon: 'ic_allow.svg',
                        }
                    }
                } catch (e) {
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                }
            },

            selectedPlace(placeId) {
                this.createPlaceAction(placeId).then((response) => {
                    this.showEnterQuestionIdDialog(response.place)
                    this.getListWithoutCoords();
                })
            },

            showEnterQuestionIdDialog(place) {
                let address = place.address ? ` (${place.address})` : ''
                this.customModalSettings = {
                    message: `Please enter question id to connect to the place "${place.place_name || place.name}${address}"`,
                    onOkHandler: this.connectSpecificQuestionToPlaceForAdmin.bind(null),
                    showCancelButton: true,
                    place: place,
                    input: {
                        value: '',
                        disabled: false
                    },
                    okButtonText: this.translate('yes'),
                    cancelButtonText: this.translate('no'),
                }
            },

            closeDialog() {
                this.onCloseSearch()
                this.$router.go(-1);
            },

            shownMapModal() {
                this.openMapModal()
            },

            openMapModal() {

                console.log(`openMapModal: navigator.geolocation:`, navigator.geolocation)

                this.geolocate({zoom: 18}, (lat, lng, zoom) => {
                    console.log(`navigator.geolocation.getCurrentPosition ____ :`, lat, lng, zoom)
                    const coordinates = {
                        lat: lat,
                        lng: lng
                    }
                    this.myLocation = coordinates
                    if (!this.isInitialLocationSet) {
                        this.isInitialLocationSet = true
                        this.center = coordinates
                        this.zoom = 18
                    }
                });

                setTimeout(() => {
                    this.$refs.mapModal.$mapPromise.then((map) => {
                        this.getListWithoutCoords();

                        map.addListener('click', (e) => {
                            if (e.placeId) {
                                this.selectedPlace(e.placeId)
                            }
                        });
                    });
                }, 100);
            }
        },

        mounted() {
            if (localStorage.getItem('zoom')) {
                this.center.lat = +localStorage.getItem('lat');
                this.center.lng = +localStorage.getItem('lng');
                this.zoom = +localStorage.getItem('zoom');
            } else {
                this.geolocate({zoom: 18});
            }
            this.latestConnectedPlaceUid = localStorage.getItem('ADMIN_latestConnectedPlaceUid')
            this.latestConnectedPlaceName = localStorage.getItem('ADMIN_latestConnectedPlaceName')
            this.shownMapModal()
        },
    }
</script>

<style>

    .own-business-admin {
        position: absolute;
        width: 100%;
        height: 80%;
    }

    .own-business-admin .vue-map-container {
        position: relative;
        display: block;
    }

    .own-business-admin .map-search {
        position: relative;
        width: 100%;
        box-shadow: 0px 4px 15px #a3a3a38f;
        position: relative;
        z-index: 10;
        height: 64px;
    }

    .own-business-admin .search_md_autocomplete {
        height: 64px;
        border-radius: 0;
        -webkit-box-shadow: none;
        box-shadow: none;
        border: none;
        font-size: 20px;
        font-weight: 700;
        width: 100%;
        outline: none;
        overflow: hidden;

    }



    .custom-modal .btn.btn-primary {
        border-radius: 4px;
    }

    .custom-modal .modal-icon {
        margin-bottom: 1px;
    }

    @media screen and (max-width: 375px) {
        .custom-modal .btn.btn-primary {
            width: 250px;
        }
    }

    @media screen and (max-width: 321px) {

        .custom-modal .btn.btn-primary {
            width: 250px;
        }
    }

    /**/

    .map-modal-dialog .close-search {
        position: absolute;
        top: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: translate(0, -50%) scale(1);
        right: 15px;
        width: 25px;
        height: 25px;
        z-index: 20;
        font-weight: 100;
        color: rgb(80, 80, 80);
        transition: color 0.25s ease;
        cursor: pointer;
    }

    .seach-submit {
        position: absolute;
        top: 50%;
        left: 15px;
        z-index: 20;
        margin-top: -12px;
        width: 24px;
        height: 24px;
        background: url('../../assets/images/ic_search.png') 50% no-repeat;
        cursor: pointer;
    }

    .getgeo {
        height: 55px;
        width: 55px;
        position: absolute;
        right: 0.5em;
        bottom: 5.3em;
        border-radius: 50%;
        background: url('../../assets/icons/mylocation_button.svg');
        background-position: center;
        background-size: cover;
        outline: none;
        border: 0;
        opacity: 0.7;
    }

    .latest-place-btn {
        position: absolute;
        cursor: pointer;
        padding: 15px 15px;
        border-radius: 3px;
        top: 100px;
        font-size: 17px;
        left: 50%;
        transform: translate(-50%, 0);
        background: #fff;
        box-shadow: 0 0 10px rgba(109, 109, 109, 0.3);
    }

    .gm-style-iw-a > .gm-style-iw-t {
        display: none;
    }



</style>
<style scoped>
    .md-button .md-ripple {
        display: none !important;
    }
    .md-menu-content .md-theme-default:last-child {
        font-size: small;
        color: gray;
    }
    .businessDropdown__wrapper {
        display: flex;
        align-items: center;
    }
    .md-field.md-clearable .md-input {
        padding-left: 45px;
        overflow: hidden;
    }
    .md-field {
        padding-left: 50px !important;
    }


</style>

